import React from "react";

export default (prop) => (
  <div {...prop} role="button" className="button" onClick={() => prop.onClick()}>
    {prop.children}
  </div>
);
